import script from "./TableRoster.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableRoster.vue?vue&type=script&setup=true&lang=ts"

import "./TableRoster.vue?vue&type=style&index=0&id=46633b67&lang=scss"

const __exports__ = script;

export default __exports__